<!--fieldset class="mt-3">
    <legend>Training Assessment Details</legend-->

<div>
    <div class="assessment-feedback" *ngFor="let question of FeedbackSubmissionOptionsList(); let i = index">
        <div class="question-wrapper">
            <span class="serial-number">{{ i + 1 }}.</span>
            <p class="question-text">{{ question.description }}</p>
        </div>
        <mat-radio-group class="radio-group-container" [value]="selectedAnswers()[question.id]"
            (change)="onOptionChange(question.id, $event.value)">
            <mat-radio-button *ngFor="let option of question.feedackoptions" [value]="option.optionsid"
                class="radio-button-item w-full">
                {{ option.description }}
            </mat-radio-button>
        </mat-radio-group>

    </div>

</div>

@if (!HideSaveButton()){
<div class="submit-button-container" style="display: flex; justify-content: center; margin-top: 15px;">
    <button class="btn-action-save" (click)="saveFeedback()">
        <span class="material-symbols-outlined">save</span> Save
    </button>
</div>
}
<!--/fieldset-->